//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
export default {
  name: "",
  data() {
    return {
      user: "",
      password: ""
    };
  },
  mounted() {},
  methods: {
    doLogin() {
      if (this.user == "" || this.password == "") {
        this.$message({
          message: "请输入账号或密码",
          type: "warning"
        });
      } else {
        let formTmp = new FormData();
        formTmp.append("type", "doLogin");
        formTmp.append("user", this.user);
        formTmp.append("password", this.password);
        const loading = this.$loading();
        axios.post(this.$apiUrl, formTmp).then(data => {
          // console.log(data.data);
          loading.close();
          if (data.data.success == true) {
            this.$message({
              message: data.data.msg,
              type: "success"
            });
            sessionStorage.setItem("user", this.user);
            sessionStorage.setItem(
              "time",
              (new Date().getTime() / 1000).toFixed(0)
            );
            sessionStorage.setItem("Authorization", data.data.data);
            // this.$router.push('/manage')
            this.$router.push("/manage/dataQuery");
          } else {
            this.$message.error(data.data.msg);
          }
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Login.vue